module.exports = __webpack_public_path__ + "880f3097e1150d1c4abf1b593bd83245.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarity_diamond_ring.png
// module id = 336
// module chunks = 0